export default __webpack_public_path__ + "static/media/image-7.79c56932.webp";